import { Pipe } from "@angular/core";

@Pipe({
    name: "line_break",
    standalone: false
})
export class LineBreakPipe {
    transform(text: string): string {
    return text.replaceAll(",","\n")
    }
}